import { render, staticRenderFns } from "./MainArchives.vue?vue&type=template&id=4af5f65a&scoped=true&"
import script from "./MainArchives.vue?vue&type=script&lang=ts&"
export * from "./MainArchives.vue?vue&type=script&lang=ts&"
import style0 from "./MainArchives.vue?vue&type=style&index=0&id=4af5f65a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5f65a",
  null
  
)

export default component.exports